import { TransportCoverDualIcon, TransportCoverDualOpenIcon, TransportCoverIcon, TransportCoverOpenIcon } from 'app/icons';
import React from 'react';
import { COLOR_CLASSES } from '../TabPanelCondition.constants';
import { GuardState } from '../TabPanelCondition.types';
export const CoverIcon = ({ hasDualCover, isOpen, position, guardStatus, guardOut, guardOutBit, disabled = false, config, }) => {
    const viewBox = '0 0 64 64';
    if (disabled) {
        const Icon = hasDualCover ? TransportCoverDualIcon : TransportCoverIcon;
        return React.createElement(Icon, { viewBox: viewBox, disabled: true });
    }
    if (guardStatus !== config.conditions.guard_status.default) {
        return hasDualCover ? (React.createElement(DualCoverIconByGuardStatus, { guardStatus: guardStatus, guardOut: guardOut, guardOutBit: guardOutBit, isOpen: isOpen, position: position, viewBox: viewBox, config: config })) : (React.createElement(SingleCoverIconByGuardStatus, { guardStatus: guardStatus, guardOut: guardOut, guardOutBit: guardOutBit, isOpen: isOpen, viewBox: viewBox, config: config }));
    }
    const Icon = hasDualCover ? TransportCoverDualIcon : TransportCoverIcon;
    return React.createElement(Icon, { viewBox: viewBox, disabled: true });
};
const DualCoverIconByGuardStatus = ({ guardStatus, guardOut, guardOutBit, isOpen, position, viewBox, config, }) => {
    if (guardStatus === GuardState.UNLOCKED) {
        if (isOpen) {
            return React.createElement(TransportCoverDualOpenIcon, { viewBox: viewBox, className: COLOR_CLASSES.INHERIT, position: position });
        }
        return React.createElement(TransportCoverDualIcon, { viewBox: viewBox, className: COLOR_CLASSES.INHERIT });
    }
    if (guardOut !== config.conditions.guard_out.default) {
        const colorClass = guardOutBit === GuardState.UNLOCKED ? COLOR_CLASSES.PRIMARY : COLOR_CLASSES.ERROR;
        return React.createElement(TransportCoverDualOpenIcon, { viewBox: viewBox, className: colorClass });
    }
    return React.createElement(TransportCoverDualOpenIcon, { viewBox: viewBox, className: COLOR_CLASSES.INHERIT });
};
const SingleCoverIconByGuardStatus = ({ guardStatus, guardOut, guardOutBit, isOpen, viewBox, config, }) => {
    if (guardStatus === GuardState.UNLOCKED) {
        const Icon = isOpen ? TransportCoverOpenIcon : TransportCoverIcon;
        return React.createElement(Icon, { viewBox: viewBox, className: COLOR_CLASSES.INHERIT });
    }
    if (guardOut !== config.conditions.guard_out.default) {
        const colorClass = guardOutBit === GuardState.UNLOCKED ? COLOR_CLASSES.PRIMARY : COLOR_CLASSES.ERROR;
        return React.createElement(TransportCoverOpenIcon, { viewBox: viewBox, className: colorClass });
    }
    return React.createElement(TransportCoverOpenIcon, { viewBox: viewBox, className: COLOR_CLASSES.INHERIT });
};
